/* Jeux d'Échec : partie d'échecs contre l'ordinateur (section bvx-chess-play).
   Moteur complet (roque, prise en passant, promotion, échec et mat, pat, nulles),
   adversaire alpha-bêta à trois niveaux, notation algébrique française. Sans dépendance. */
(function () {
  'use strict';
  var FILES = 'abcdefgh';
  var VAL = { p: 100, n: 320, b: 330, r: 500, q: 900, k: 0 };
  var FR = { p: '', n: 'C', b: 'F', r: 'T', q: 'D', k: 'R' };
  var NAME = { p: 'pion', n: 'cavalier', b: 'fou', r: 'tour', q: 'dame', k: 'roi' };
  var GLYPH = { k: '♚', q: '♛', r: '♜', b: '♝', n: '♞', p: '♟' };
  var MATE = 100000;
  // Tables de position (vue des Blancs, rangée 8 en haut).
  var PST = {
    p: [0,0,0,0,0,0,0,0, 50,50,50,50,50,50,50,50, 10,10,20,30,30,20,10,10, 5,5,10,25,25,10,5,5,
        0,0,0,20,20,0,0,0, 5,-5,-10,0,0,-10,-5,5, 5,10,10,-20,-20,10,10,5, 0,0,0,0,0,0,0,0],
    n: [-50,-40,-30,-30,-30,-30,-40,-50, -40,-20,0,0,0,0,-20,-40, -30,0,10,15,15,10,0,-30, -30,5,15,20,20,15,5,-30,
        -30,0,15,20,20,15,0,-30, -30,5,10,15,15,10,5,-30, -40,-20,0,5,5,0,-20,-40, -50,-40,-30,-30,-30,-30,-40,-50],
    b: [-20,-10,-10,-10,-10,-10,-10,-20, -10,0,0,0,0,0,0,-10, -10,0,5,10,10,5,0,-10, -10,5,5,10,10,5,5,-10,
        -10,0,10,10,10,10,0,-10, -10,10,10,10,10,10,10,-10, -10,5,0,0,0,0,5,-10, -20,-10,-10,-10,-10,-10,-10,-20],
    r: [0,0,0,0,0,0,0,0, 5,10,10,10,10,10,10,5, -5,0,0,0,0,0,0,-5, -5,0,0,0,0,0,0,-5,
        -5,0,0,0,0,0,0,-5, -5,0,0,0,0,0,0,-5, -5,0,0,0,0,0,0,-5, 0,0,0,5,5,0,0,0],
    q: [-20,-10,-10,-5,-5,-10,-10,-20, -10,0,0,0,0,0,0,-10, -10,0,5,5,5,5,0,-10, -5,0,5,5,5,5,0,-5,
        0,0,5,5,5,5,0,-5, -10,5,5,5,5,5,0,-10, -10,0,5,0,0,0,0,-10, -20,-10,-10,-5,-5,-10,-10,-20],
    k: [-30,-40,-40,-50,-50,-40,-40,-30, -30,-40,-40,-50,-50,-40,-40,-30, -30,-40,-40,-50,-50,-40,-40,-30, -30,-40,-40,-50,-50,-40,-40,-30,
        -20,-30,-30,-40,-40,-30,-30,-20, -10,-20,-20,-20,-20,-20,-20,-10, 20,20,0,0,0,0,20,20, 20,30,10,0,0,10,30,20]
  };

  function white(p) { return p !== '' && p === p.toUpperCase(); }
  function colorOf(p) { return p === '' ? '' : (white(p) ? 'w' : 'b'); }
  function sqName(i) { return FILES[i % 8] + (8 - (i >> 3)); }

  function initial() {
    var b = 'rnbqkbnrpppppppp'.split('').concat(Array(32).fill(''), 'PPPPPPPPRNBQKBNR'.split(''));
    return { b: b, turn: 'w', cr: { K: true, Q: true, k: true, q: true }, ep: -1, half: 0, full: 1 };
  }

  function attacked(b, sq, by) {
    var r = sq >> 3, c = sq & 7, i, d, rr, cc, p;
    if (by === 'w') {
      if (r + 1 < 8) { if (c > 0 && b[(r + 1) * 8 + c - 1] === 'P') return true; if (c < 7 && b[(r + 1) * 8 + c + 1] === 'P') return true; }
    } else {
      if (r - 1 >= 0) { if (c > 0 && b[(r - 1) * 8 + c - 1] === 'p') return true; if (c < 7 && b[(r - 1) * 8 + c + 1] === 'p') return true; }
    }
    var N = by === 'w' ? 'N' : 'n', K = by === 'w' ? 'K' : 'k', R = by === 'w' ? 'R' : 'r', B = by === 'w' ? 'B' : 'b', Q = by === 'w' ? 'Q' : 'q';
    var kn = [[-2,-1],[-2,1],[-1,-2],[-1,2],[1,-2],[1,2],[2,-1],[2,1]];
    for (i = 0; i < 8; i++) { rr = r + kn[i][0]; cc = c + kn[i][1]; if (rr >= 0 && rr < 8 && cc >= 0 && cc < 8 && b[rr * 8 + cc] === N) return true; }
    for (rr = -1; rr <= 1; rr++) for (cc = -1; cc <= 1; cc++) {
      if (!rr && !cc) continue;
      var r2 = r + rr, c2 = c + cc;
      if (r2 >= 0 && r2 < 8 && c2 >= 0 && c2 < 8 && b[r2 * 8 + c2] === K) return true;
    }
    var dirs = [[1,0,R],[-1,0,R],[0,1,R],[0,-1,R],[1,1,B],[1,-1,B],[-1,1,B],[-1,-1,B]];
    for (i = 0; i < 8; i++) {
      d = dirs[i]; rr = r + d[0]; cc = c + d[1];
      while (rr >= 0 && rr < 8 && cc >= 0 && cc < 8) {
        p = b[rr * 8 + cc];
        if (p !== '') { if (p === d[2] || p === Q) return true; break; }
        rr += d[0]; cc += d[1];
      }
    }
    return false;
  }

  function kingSq(b, col) { var k = col === 'w' ? 'K' : 'k'; return b.indexOf(k); }
  function inCheck(s, col) { return attacked(s.b, kingSq(s.b, col), col === 'w' ? 'b' : 'w'); }

  function pseudo(s) {
    var b = s.b, us = s.turn, them = us === 'w' ? 'b' : 'w', out = [], i, r, c, p, t, k;
    function add(f, to, extra) {
      var m = { f: f, t: to, p: b[f], x: b[to] };
      if (extra) for (k in extra) m[k] = extra[k];
      out.push(m);
    }
    function addPawn(f, to, cap) {
      var lr = to >> 3;
      if (lr === 0 || lr === 7) { ['q', 'r', 'b', 'n'].forEach(function (pr) { add(f, to, { promo: pr }); }); }
      else add(f, to);
    }
    for (i = 0; i < 64; i++) {
      p = b[i]; if (p === '' || colorOf(p) !== us) continue;
      r = i >> 3; c = i & 7; var lp = p.toLowerCase();
      if (lp === 'p') {
        var dir = us === 'w' ? -1 : 1, one = (r + dir) * 8 + c, start = us === 'w' ? 6 : 1;
        if (r + dir >= 0 && r + dir < 8 && b[one] === '') {
          addPawn(i, one);
          var two = (r + 2 * dir) * 8 + c;
          if (r === start && b[two] === '') add(i, two, { dbl: true });
        }
        [-1, 1].forEach(function (dc) {
          var cc = c + dc, rr = r + dir; if (cc < 0 || cc > 7 || rr < 0 || rr > 7) return;
          var to = rr * 8 + cc;
          if (b[to] !== '' && colorOf(b[to]) === them) addPawn(i, to, true);
          else if (to === s.ep) add(i, to, { ep: true, x: us === 'w' ? 'p' : 'P' });
        });
      } else if (lp === 'n' || lp === 'k') {
        var offs = lp === 'n' ? [[-2,-1],[-2,1],[-1,-2],[-1,2],[1,-2],[1,2],[2,-1],[2,1]] : [[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]];
        offs.forEach(function (o) {
          var rr = r + o[0], cc = c + o[1]; if (rr < 0 || rr > 7 || cc < 0 || cc > 7) return;
          t = b[rr * 8 + cc]; if (t === '' || colorOf(t) === them) add(i, rr * 8 + cc);
        });
        if (lp === 'k') {
          var home = us === 'w' ? 60 : 4, KS = us === 'w' ? 'K' : 'k', QS = us === 'w' ? 'Q' : 'q', rook = us === 'w' ? 'R' : 'r';
          if (i === home && !attacked(b, home, them)) {
            if (s.cr[KS] && b[home + 1] === '' && b[home + 2] === '' && b[home + 3] === rook && !attacked(b, home + 1, them) && !attacked(b, home + 2, them)) add(i, home + 2, { castle: 'K' });
            if (s.cr[QS] && b[home - 1] === '' && b[home - 2] === '' && b[home - 3] === '' && b[home - 4] === rook && !attacked(b, home - 1, them) && !attacked(b, home - 2, them)) add(i, home - 2, { castle: 'Q' });
          }
        }
      } else {
        var dl = lp === 'r' ? [[1,0],[-1,0],[0,1],[0,-1]] : lp === 'b' ? [[1,1],[1,-1],[-1,1],[-1,-1]] : [[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]];
        dl.forEach(function (d) {
          var rr = r + d[0], cc = c + d[1];
          while (rr >= 0 && rr < 8 && cc >= 0 && cc < 8) {
            t = b[rr * 8 + cc];
            if (t === '') add(i, rr * 8 + cc);
            else { if (colorOf(t) === them) add(i, rr * 8 + cc); break; }
            rr += d[0]; cc += d[1];
          }
        });
      }
    }
    return out;
  }

  function make(s, m) {
    var b = s.b.slice(), us = s.turn, cr = { K: s.cr.K, Q: s.cr.Q, k: s.cr.k, q: s.cr.q };
    var p = b[m.f];
    b[m.t] = m.promo ? (us === 'w' ? m.promo.toUpperCase() : m.promo) : p;
    b[m.f] = '';
    if (m.ep) b[m.t + (us === 'w' ? 8 : -8)] = '';
    if (m.castle === 'K') { b[m.t - 1] = b[m.t + 1]; b[m.t + 1] = ''; }
    if (m.castle === 'Q') { b[m.t + 1] = b[m.t - 2]; b[m.t - 2] = ''; }
    if (p === 'K') { cr.K = cr.Q = false; }
    if (p === 'k') { cr.k = cr.q = false; }
    [m.f, m.t].forEach(function (q) { if (q === 63) cr.K = false; if (q === 56) cr.Q = false; if (q === 7) cr.k = false; if (q === 0) cr.q = false; });
    var pawn = p.toLowerCase() === 'p';
    return { b: b, turn: us === 'w' ? 'b' : 'w', cr: cr, ep: m.dbl ? (m.f + m.t) >> 1 : -1,
      half: (pawn || m.x) ? 0 : s.half + 1, full: s.full + (us === 'b' ? 1 : 0) };
  }

  function legal(s) {
    var us = s.turn;
    return pseudo(s).filter(function (m) { return !inCheck(make(s, m), us); });
  }

  function key(s) { return s.b.join('') + s.turn + (s.cr.K ? 'K' : '') + (s.cr.Q ? 'Q' : '') + (s.cr.k ? 'k' : '') + (s.cr.q ? 'q' : '') + s.ep; }

  function insufficient(b) {
    var minors = [], i, p;
    for (i = 0; i < 64; i++) {
      p = b[i]; if (p === '' || p.toLowerCase() === 'k') continue;
      var lp = p.toLowerCase();
      if (lp === 'p' || lp === 'r' || lp === 'q') return false;
      minors.push({ p: lp, sq: i });
    }
    if (minors.length === 0) return true;
    if (minors.length === 1) return true;
    // fous de même couleur de case uniquement
    return minors.every(function (m) { return m.p === 'b'; }) &&
      minors.every(function (m) { return (((m.sq >> 3) + (m.sq & 7)) & 1) === (((minors[0].sq >> 3) + (minors[0].sq & 7)) & 1); });
  }

  function evaluate(s) {
    var b = s.b, score = 0, i, p, lp;
    for (i = 0; i < 64; i++) {
      p = b[i]; if (p === '') continue; lp = p.toLowerCase();
      if (white(p)) score += VAL[lp] + PST[lp][i];
      else score -= VAL[lp] + PST[lp][(7 - (i >> 3)) * 8 + (i & 7)];
    }
    return s.turn === 'w' ? score : -score;
  }

  function order(ms) {
    return ms.sort(function (a, b) {
      var va = (a.x ? 10 * VAL[a.x.toLowerCase()] - VAL[a.p.toLowerCase()] : 0) + (a.promo ? 800 : 0);
      var vb = (b.x ? 10 * VAL[b.x.toLowerCase()] - VAL[b.p.toLowerCase()] : 0) + (b.promo ? 800 : 0);
      return vb - va;
    });
  }

  function Search(deadline) { this.deadline = deadline; this.nodes = 0; }
  Search.prototype.tick = function () { if ((++this.nodes & 1023) === 0 && Date.now() > this.deadline) throw 'temps'; };
  Search.prototype.quiesce = function (s, alpha, beta, qd) {
    this.tick();
    var stand = evaluate(s);
    if (stand >= beta) return beta;
    if (alpha < stand) alpha = stand;
    if (qd <= 0) return alpha;
    var ms = order(legal(s).filter(function (m) { return m.x || m.promo; }));
    for (var i = 0; i < ms.length; i++) {
      var sc = -this.quiesce(make(s, ms[i]), -beta, -alpha, qd - 1);
      if (sc >= beta) return beta;
      if (sc > alpha) alpha = sc;
    }
    return alpha;
  };
  Search.prototype.negamax = function (s, depth, alpha, beta, ply) {
    this.tick();
    var ms = legal(s);
    if (!ms.length) return inCheck(s, s.turn) ? -MATE + ply : 0;
    if (s.half >= 100 || insufficient(s.b)) return 0;
    if (depth <= 0) return this.quiesce(s, alpha, beta, 4);
    order(ms);
    for (var i = 0; i < ms.length; i++) {
      var sc = -this.negamax(make(s, ms[i]), depth - 1, -beta, -alpha, ply + 1);
      if (sc >= beta) return beta;
      if (sc > alpha) alpha = sc;
    }
    return alpha;
  };

  function think(s, level) {
    var ms = order(legal(s));
    if (!ms.length) return null;
    var cfg = level === 1 ? { depth: 1, ms: 300, noise: 90 } : level === 2 ? { depth: 2, ms: 900, noise: 25 } : { depth: 4, ms: 1600, noise: 0 };
    var srch = new Search(Date.now() + cfg.ms), best = ms[0], scored = ms.map(function (m) { return { m: m, s: 0 }; });
    for (var d = 1; d <= cfg.depth; d++) {
      try {
        var cur = [];
        for (var i = 0; i < ms.length; i++) cur.push({ m: ms[i], s: -srch.negamax(make(s, ms[i]), d - 1, -MATE - 1, MATE + 1, 1) });
        cur.sort(function (a, b) { return b.s - a.s; });
        scored = cur; ms = cur.map(function (x) { return x.m; });
        if (Math.abs(cur[0].s) > MATE - 1000) break;   // mat trouvé : inutile de chercher plus loin
      } catch (e) { if (e !== 'temps') throw e; break; }
    }
    if (cfg.noise) {
      var top = scored[0].s, pool = scored.filter(function (x) { return x.s >= top - cfg.noise && Math.abs(top) < MATE - 1000; });
      if (pool.length) return pool[Math.floor(Math.random() * pool.length)].m;
    }
    best = scored[0].m;
    return best;
  }

  function san(s, m, ms) {
    var str;
    if (m.castle) str = m.castle === 'K' ? 'O-O' : 'O-O-O';
    else {
      var lp = m.p.toLowerCase(), cap = !!m.x;
      if (lp === 'p') str = (cap ? FILES[m.f & 7] + 'x' : '') + sqName(m.t) + (m.promo ? '=' + FR[m.promo] : '');
      else {
        var amb = ms.filter(function (o) { return o.t === m.t && o.p === m.p && o.f !== m.f; }), dis = '';
        if (amb.length) {
          var sameFile = amb.some(function (o) { return (o.f & 7) === (m.f & 7); }), sameRank = amb.some(function (o) { return (o.f >> 3) === (m.f >> 3); });
          if (!sameFile) dis = FILES[m.f & 7]; else if (!sameRank) dis = String(8 - (m.f >> 3)); else dis = sqName(m.f);
        }
        str = FR[lp] + dis + (cap ? 'x' : '') + sqName(m.t);
      }
    }
    var ns = make(s, m);
    if (inCheck(ns, ns.turn)) str += legal(ns).length ? '+' : '#';
    return str;
  }

  /* ---------- Interface ---------- */
  function Game(root) {
    this.root = root;
    this.boardEl = root.querySelector('[data-chess-board]');
    this.statusEl = root.querySelector('[data-chess-status]');
    this.movesEl = root.querySelector('[data-chess-moves]');
    this.levelEl = root.querySelector('[data-chess-level]');
    this.endEl = root.querySelector('[data-chess-end]');
    this.promoEl = root.querySelector('[data-chess-promo]');
    this.human = root.getAttribute('data-human') === 'b' ? 'b' : 'w';
    if (this.levelEl) this.levelEl.value = root.getAttribute('data-level') || '2';
    this.build(); this.bind(); this.reset();
  }
  Game.prototype.build = function () {
    var html = '';
    for (var i = 0; i < 64; i++) html += '<button type="button" class="bvx-ch__sq" data-i="' + i + '"><span class="bvx-ch__pc" aria-hidden="true"></span></button>';
    this.boardEl.innerHTML = html;
    this.sqEls = Array.prototype.slice.call(this.boardEl.querySelectorAll('.bvx-ch__sq'));
  };
  Game.prototype.bind = function () {
    var g = this;
    this.boardEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.bvx-ch__sq'); if (!btn) return;
      g.tap(g.viewToSq(+btn.getAttribute('data-i')));
    });
    this.root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-chess-action]'); if (!a) return;
      var act = a.getAttribute('data-chess-action');
      if (act === 'new') g.reset();
      if (act === 'undo') g.undo();
      if (act === 'flip') { g.human = g.human === 'w' ? 'b' : 'w'; g.reset(); }
      if (act === 'promo') g.finishPromo(a.getAttribute('data-p'));
    });
    if (this.levelEl) this.levelEl.addEventListener('change', function () { g.render(); });
  };
  Game.prototype.viewToSq = function (v) { return this.human === 'w' ? v : 63 - v; };
  Game.prototype.reset = function () {
    this.s = initial(); this.hist = []; this.sans = []; this.sel = -1; this.last = null; this.over = null;
    this.reps = {}; this.reps[key(this.s)] = 1; this.pending = null; this.busy = false;
    if (this.endEl) this.endEl.hidden = true;
    if (this.promoEl) this.promoEl.hidden = true;
    this.render();
    if (this.s.turn !== this.human) this.aiMove();
  };
  Game.prototype.level = function () { return this.levelEl ? +this.levelEl.value : 2; };
  Game.prototype.tap = function (sq) {
    if (this.over || this.busy || this.s.turn !== this.human || this.pending) return;
    var p = this.s.b[sq];
    if (this.sel >= 0) {
      var cands = legal(this.s).filter(function (m) { return m.f === this.sel && m.t === sq; }, this);
      if (cands.length) {
        if (cands.length > 1) { this.pending = cands; this.showPromo(); return; }
        this.play(cands[0]); return;
      }
    }
    this.sel = (p !== '' && colorOf(p) === this.human) ? sq : -1;
    this.render();
  };
  Game.prototype.showPromo = function () {
    if (!this.promoEl) { this.finishPromo('q'); return; }
    var col = this.human;
    Array.prototype.forEach.call(this.promoEl.querySelectorAll('[data-p]'), function (b) {
      b.querySelector('span').className = 'bvx-ch__pc bvx-ch__pc--' + col;
    });
    this.promoEl.hidden = false;
    var first = this.promoEl.querySelector('button'); if (first) first.focus();
  };
  Game.prototype.finishPromo = function (pr) {
    if (!this.pending) return;
    var m = this.pending.filter(function (x) { return x.promo === pr; })[0] || this.pending[0];
    this.pending = null; if (this.promoEl) this.promoEl.hidden = true;
    this.play(m);
  };
  Game.prototype.play = function (m) {
    var ms = legal(this.s);
    this.hist.push({ s: this.s, last: this.last, reps: JSON.stringify(this.reps) });
    this.sans.push(san(this.s, m, ms));
    this.s = make(this.s, m); this.last = m; this.sel = -1;
    var k = key(this.s); this.reps[k] = (this.reps[k] || 0) + 1;
    this.checkEnd(); this.render();
    if (!this.over && this.s.turn !== this.human) this.aiMove();
  };
  Game.prototype.aiMove = function () {
    var g = this; g.busy = true; g.render();
    setTimeout(function () {
      var m = think(g.s, g.level());
      g.busy = false;
      if (m) g.play(m); else g.render();
    }, 350);
  };
  Game.prototype.undo = function () {
    if (this.busy || !this.hist.length) return;
    // revient au dernier coup du joueur
    var steps = this.s.turn === this.human ? 2 : 1;
    while (steps-- > 0 && this.hist.length) {
      var h = this.hist.pop(); this.s = h.s; this.last = h.last; this.reps = JSON.parse(h.reps); this.sans.pop();
    }
    if (this.s.turn !== this.human && this.hist.length === 0) { this.reset(); return; }
    this.over = null; this.sel = -1; if (this.endEl) this.endEl.hidden = true;
    this.render();
    if (this.s.turn !== this.human) this.aiMove();
  };
  Game.prototype.checkEnd = function () {
    var ms = legal(this.s), mover = this.s.turn;
    if (!ms.length) {
      if (inCheck(this.s, mover)) this.over = mover === this.human ? 'lose' : 'win';
      else this.over = 'pat';
    } else if (this.s.half >= 100) this.over = 'cinquante';
    else if (this.reps[key(this.s)] >= 3) this.over = 'repetition';
    else if (insufficient(this.s.b)) this.over = 'materiel';
    if (this.over && this.endEl) {
      var T = { win: ['Échec et mat !', 'Vous avez gagné. Bravo, belle partie.'],
        lose: ['Échec et mat', "L'ordinateur l'emporte cette fois. Une revanche ?"],
        pat: ['Pat : partie nulle', "Le camp au trait n'a plus aucun coup légal sans être en échec."],
        cinquante: ['Partie nulle', 'Cinquante coups sans prise ni mouvement de pion.'],
        repetition: ['Partie nulle', 'La même position est apparue trois fois.'],
        materiel: ['Partie nulle', 'Il ne reste plus assez de pièces pour mater.'] }[this.over];
      this.endEl.querySelector('[data-chess-end-title]').textContent = T[0];
      this.endEl.querySelector('[data-chess-end-text]').textContent = T[1];
      var g = this; setTimeout(function () { g.endEl.hidden = false; }, 600);
    }
  };
  Game.prototype.render = function () {
    var s = this.s, g = this, targets = {}, check = -1;
    if (this.sel >= 0) legal(s).forEach(function (m) { if (m.f === g.sel) targets[m.t] = m.x ? 'cap' : 'mv'; });
    if (inCheck(s, s.turn)) check = kingSq(s.b, s.turn);
    this.sqEls.forEach(function (el, v) {
      var i = g.viewToSq(v), p = s.b[i], r = i >> 3, c = i & 7, cls = 'bvx-ch__sq ' + (((r + c) & 1) ? 'is-dark' : 'is-light');
      if (i === g.sel) cls += ' is-sel';
      if (g.last && (i === g.last.f || i === g.last.t)) cls += ' is-last';
      if (targets[i]) cls += targets[i] === 'cap' ? ' is-cap' : ' is-mv';
      if (i === check) cls += ' is-check';
      el.className = cls;
      var pc = el.firstChild;
      pc.textContent = p ? GLYPH[p.toLowerCase()] + '︎' : '';
      pc.className = 'bvx-ch__pc' + (p ? ' bvx-ch__pc--' + colorOf(p) : '');
      var rowView = v >> 3, colView = v & 7, coord = '';
      if (colView === 0) coord += '<i class="bvx-ch__rk">' + (8 - r) + '</i>';
      if (rowView === 7) coord += '<i class="bvx-ch__fl">' + FILES[c] + '</i>';
      var old = el.querySelectorAll('i'); Array.prototype.forEach.call(old, function (x) { x.remove(); });
      if (coord) el.insertAdjacentHTML('beforeend', coord);
      el.setAttribute('aria-label', sqName(i) + (p ? ', ' + NAME[p.toLowerCase()] + (white(p) ? ' blanc' : ' noir') : ', vide') + (targets[i] ? ', coup possible' : ''));
    });
    if (this.statusEl) {
      var txt;
      if (this.over) txt = { win: 'Échec et mat : vous avez gagné !', lose: "Échec et mat : l'ordinateur gagne.", pat: 'Pat : partie nulle.', cinquante: 'Partie nulle (50 coups).', repetition: 'Partie nulle (triple répétition).', materiel: 'Partie nulle (matériel insuffisant).' }[this.over];
      else if (this.busy) txt = "L'ordinateur réfléchit…";
      else if (s.turn === this.human) txt = (check >= 0 ? 'Échec ! ' : '') + 'À vous de jouer (' + (this.human === 'w' ? 'Blancs' : 'Noirs') + ').';
      else txt = "Au tour de l'ordinateur.";
      this.statusEl.textContent = txt;
    }
    this.root.classList.toggle('is-busy', !!this.busy);
    if (this.movesEl) {
      var out = '';
      for (var k = 0; k < this.sans.length; k += 2) out += '<li><b>' + (k / 2 + 1) + '.</b> ' + this.sans[k] + (this.sans[k + 1] ? ' ' + this.sans[k + 1] : '') + '</li>';
      this.movesEl.innerHTML = out || '<li class="bvx-ch__empty">Les coups de la partie s’afficheront ici.</li>';
      this.movesEl.scrollTop = this.movesEl.scrollHeight;
    }
  };

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-chess]'), function (root) {
      if (root.__chess) return; root.__chess = new Game(root);
    });
  }
  window.BvxChess = { legal: legal, make: make, initial: initial, inCheck: inCheck, san: san, think: think, key: key, insufficient: insufficient };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
